export default function xmlTypeLabel(value, t) {
  if (value === "quantitative") return t("quantitative");
  if (value === "summary") return t("summary");
  return value || "";
}
